var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransit10On(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11 5.44772 11.4477 5 12 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H12C11.4477 7 11 6.55228 11 6Z",
    fill: "#196BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17H5V11H7.25V14H8.75V11H11V17Z",
    fill: "#4AD35E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27H5V21H7.25V24H8.75V21H11V27Z",
    fill: "#4AD35E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H25V13H13V11Z",
    fill: "#196BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21H25V23H13V21Z",
    fill: "#196BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H20V17H13V15Z",
    fill: "#196BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25H20V27H13V25Z",
    fill: "#196BFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 33.5,
    r: 8.5,
    fill: "#4AD35E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28 0C29.1046 0 30 0.895431 30 2V23.1084C29.1638 23.228 28.3601 23.4465 27.5996 23.751V2.40039H2.40039V31.5996H21.1748C21.0621 32.2161 21 32.8509 21 33.5C21 33.6676 21.0049 33.8343 21.0127 34H2L1.7959 33.9893C0.854346 33.8938 0.1062 33.1457 0.0107422 32.2041L0 32V2C0 0.895431 0.895431 5.63724e-08 2 0H28Z",
    fill: "#196BFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3883 30.2167C35.7732 29.9101 36.344 29.9286 36.707 30.2738C37.0699 30.619 37.0962 31.168 36.7832 31.5426L36.7158 31.6152L31.1979 37L26.3318 32.8454L26.2596 32.7766C25.9216 32.4229 25.9095 31.8731 26.2476 31.5055C26.5859 31.1378 27.1547 31.0831 27.5599 31.3642L27.6385 31.4245L31.1073 34.386L35.3145 30.2823L35.3883 30.2167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransit10On);
export default __webpack_public_path__ + "static/media/transit10On.7b6f289dc937222b1332265419084116.svg";
export { ForwardRef as ReactComponent };